import { createContext, useContext } from 'react';

export type DataIntegrationStepControls = {
  title: string;
  subtitle: string;
  currentStep: number;
  onNext?: () => void | Promise<void>;
  onBack?: () => void | Promise<void>;
  isBackDisabled: boolean;
  isNextDisabled: boolean;
  isFormValid?: boolean;
  // Overrides the sidebar "Next" button label (e.g. "Skip")
  nextLabel?: string;
};

export type DataIntegrationStepControlsContextValue = {
  controls: DataIntegrationStepControls;
  setControls: (next: DataIntegrationStepControls) => void;
};

export const defaultControls: DataIntegrationStepControls = {
  title: '',
  subtitle: '',
  currentStep: 1,
  onNext: undefined,
  onBack: undefined,
  isBackDisabled: true,
  isNextDisabled: false,
  isFormValid: true,
};

export const DataIntegrationStepControlsContext =
  createContext<DataIntegrationStepControlsContextValue | null>(null);
DataIntegrationStepControlsContext.displayName =
  'DataIntegrationStepControlsContext';

export function useDataIntegrationStepControls() {
  const ctx = useContext(DataIntegrationStepControlsContext);
  if (!ctx) {
    throw new Error(
      'useDataIntegrationStepControls must be used within DataIntegrationStepControlsProvider',
    );
  }
  return ctx;
}
